module.exports = __webpack_public_path__ + "img/richard-ingle.d31e3f36.png";